'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Types = require('../types/Types');

var _Types2 = _interopRequireDefault(_Types);

var _MethodCreator = require('./MethodCreator');

var _MethodCreator2 = _interopRequireDefault(_MethodCreator);

var _ActionCreators = require('../change/ActionCreators');

var _ActionCreators2 = _interopRequireDefault(_ActionCreators);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _MethodCreator2.default)("Element", function (_this) {
    return {
        // change methods

        insertAfterSelf: function insertAfterSelf(value) {
            _this.dispatch(_ActionCreators2.default.insertAfterSelf(value));
        },

        insertBeforeSelf: function insertBeforeSelf(value) {
            _this.dispatch(_ActionCreators2.default.insertBeforeSelf(value));
        },

        swapNextWithSelf: function swapNextWithSelf() {
            _this.dispatch(_ActionCreators2.default.swapNextWithSelf());
        },

        swapPrevWithSelf: function swapPrevWithSelf() {
            _this.dispatch(_ActionCreators2.default.swapPrevWithSelf());
        },

        swapWithSelf: function swapWithSelf(key) {
            (0, _Types2.default)('swapWithSelf() expects param "key" to be', 'keyIndex')(key);
            _this.dispatch(_ActionCreators2.default.swapWithSelf(key));
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./~/parcels/lib/parcel/ElementParcelMethods.js
// module id = 739
// module chunks = 35783957827783